import * as React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const pages = [{
    title: "Startseite",
    path: "/HomePage"
  }, {
    title: "Reinigung im Detail",
    path: "/CleaningDetailPage"
  }, {
    title: "Preisinfo",
    path: "/PricingInfoPage"
  }, {
    title: "Kontakt",
    path: "/ContactPage"
  }, {
    title: "Weitere Dienstleistungen",
    path: "/AdditionalServicesPage"
  }, {
    title: "Referenzen",
    path: "/ReferencesAndLinksPage"
  }, {
    title: "Links",
    path: "/ReferencesAndLinksPage"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  return <section id="footer" className="bg-muted text-muted-foreground py-12 md:py-16 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://rolltreppenreinigung.yourbusiness.name/wp-content/uploads/2026/03/logo.jpg" alt="TreppenGlanz Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed max-w-xs">&nbsp;Wir stehen für höchste Qualität und Zuverlässigkeit bei der Reinigung Ihrer Fahrtreppen.</p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-foreground font-semibold tracking-tight">Navigation</h3>
            <nav className="flex flex-col gap-3">
              {pages.map((page, i) => <Link key={page.title} to={page.path} data-index={i} className="text-sm hover:text-primary transition-colors w-fit">
                  {page.title}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-foreground font-semibold tracking-tight">Kontakt</h3>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-primary" />
                <span>Jakob-Reiner-Str. 12<br />88250  Weingarten</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0 text-primary" />
                <Link to="tel:[PLATZHALTER: Telefonnummer]" className="hover:text-primary transition-colors">+49 751 20183728</Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0 text-primary" />
                <Link to="mailto:[PLATZHALTER: Kontakt-E-Mail]" className="hover:text-primary transition-colors">info@serviceteamweingarten.com</Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-foreground font-semibold tracking-tight">Folgen Sie uns</h3>
            <div className="flex gap-2">
              {socialLinks.map((social, i) => <Button key={i} variant="outline" size="icon" asChild className="rounded-full hover:bg-primary hover:text-primary-foreground border-border bg-background" data-index={i}>
                  <Link to={social.href} aria-label={social.label} newTab>
                    <social.icon className="w-4 h-4" />
                  </Link>
                </Button>)}
            </div>
            <p className="text-xs mt-4 text-muted-foreground/80">
              Bleiben Sie auf dem Laufenden über unsere neuesten Dienstleistungen und Angebote.
            </p>
          </div>
        </div>

        <Separator className="bg-border/60 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/80">
          <p>
            &copy; {new Date().getFullYear()} TreppenGlanz. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">
              [PLATZHALTER: Impressum]
            </Link>
            <Link to="#" className="hover:text-foreground transition-colors">
              [PLATZHALTER: Datenschutz]
            </Link>
          </div>
        </div>
      </div>
    </section>;
}